var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLactoseIntolerance = function SvgLactoseIntolerance(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.242 2.361c0-.426.346-.772.773-.772h3.928c.427 0 .772.346.772.772v.36l1.479 2.238v9.452H3.806v-9.45l1.436-2.238v-.362Zm.542.815-.987 1.538h3.705l1.16-1.538H5.785Zm4.562.256L9.028 5.179l.028 1.471h2.438V5.17l-1.148-1.738Zm1.148 3.918H9.069l.071 3.8h2.354v-3.8Zm0 4.5h-2.34l.034 1.861h2.306V11.85Zm-3.006 1.861-.035-1.861H4.506v1.861h3.982ZM4.506 11.15H8.44l-.071-3.8H4.506v3.8Zm0-4.5h3.85l-.024-1.236H4.506V6.65Zm5.51-4.174H5.941V2.36c0-.04.033-.072.073-.072h3.928c.04 0 .072.032.072.072v.115Z",
    fill: "currentColor"
  })));
};
export default SvgLactoseIntolerance;